<template>
	<div class="q_pad_lr15px">
		<div class="q_text_l q_bold q_center q_mar_t30px q_pad_lr20px">{{train.name}}</div>
    <div class="q_text_s q_color_gray q_center q_mar_t15px">来源：{{train.associationName}}</div>
		<div class="q_text_s q_color_gray q_center q_mar_t15px">{{train.createTime}}</div>
		<div class="q_artdea q_mar_t15px">
<!--			<p>为迎接全国第31个助残日，2021年5月17日，招远市金太阳志愿服务中心围绕“巩固残疾人脱贫成果 提高残疾人生活质量”协同招远市12349智慧养老服务中心及多家爱心商户来到文化社区开展了“以爱之名 携手同行”助残日志愿服务活动。</p>-->
<!--			<p><img src="../../assets/image/act.png" /></p>-->
<!--			<p>活动现场，服务点前有序排满了前来体验服务的老人们。金太阳志愿者细心引导解答我国各项助残政策， 医务人员态度亲切地为大家检查牙齿、测量血压，耐心地回答各类健康问题。美发师们一边按照老人的要求精心修剪各种发型，一边与老人唠着家常。</p>-->
<!--			<p>活动现场，服务点前有序排满了前来体验服务的老人们。金太阳志愿者细心引导解答我国各项助残政策， 医务人员态度亲切地为大家检查牙齿、测量血压，耐心地回答各类健康问题。美发师们一边按照老人的要求精心修剪各种发型，一边与老人唠着家常。</p>-->
		<div  class="ql-editor" v-html="train.content"></div>
    </div>
	</div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {getLrainById} from "@/api/train";
import {wxCloseShare} from "@/utils/jiutang";

export default {
    name: 'Lamedea',
    props: {
      msg: String
    },
    data() {
      return {
        train:{},
        articleId:''
      }
    },
    created() {
      wxCloseShare()
      this.articleId = this.$route.query.id;
      this.init()
    },
    methods: {
      /**
       * 初始化
       */
      init() {
        this.$modal.loading()
        //获取活动详情信息
        getLrainById(this.articleId).then((res) => {
          this.train = res.data
        }).finally(() => {
          this.$modal.closeLoading()
        })
      },
    }
  }
</script>
<style>
	.q_artdea p{
		line-height: 24px;
		font-size: 14px;
		margin-bottom: 5px;
		text-align: justify;
	}
	.q_artdea img{
		max-width: 100%;
		margin: 10px auto;
		display: block;
	}
</style>
